<template>
<kt-row v-if="status == 'setFormData'">
    <psp-select-modal v-if="dedicated.can_set_psp" :dedicated="dedicated"></psp-select-modal>
    <kt-col xs="12">
        <form @submit.prevent="edit" id="settings_form">
            <kt-form-group>
                <kt-form-label>
                    {{ $t('label.change_status') }}
                </kt-form-label>
                <kt-form-select
                        size="3"
                        id="status"
                        name="status"
                        v-model="dedicated.status"
                >
                    <option
                            v-bind:key="index"
                            v-for="(status, index) in statuses"
                            v-bind:value="status.value"
                            :selected="dedicated.status === status.value"
                    >
                        {{ status.name }}
                    </option>
                </kt-form-select>
            </kt-form-group>
            <transition name="fade">
                <kt-form-group v-if="dedicated.status == 3">
                    <kt-form-label>
                        {{ $t('label.rejection_reason') }}
                    </kt-form-label>
                    <kt-form-control
                            id="rejection_reason"
                            name="rejection_reason"
                            v-model="dedicated.rejection_reason"
                    >
                    </kt-form-control>
                </kt-form-group>
            </transition>
            <transition name="fade">
                <psp-form
                        v-if="
                        dedicated.status == 9
                        || dedicated.status == 1
                        || dedicated.status == 4
                        || dedicated.status == 10"

                        :gate_status="dedicated.status"
                />
            </transition>

            <kt-form-group>
                <kt-form-label>
                    {{ $t('label.change_wage_type') }}
                </kt-form-label>
                <kt-form-select size="3" id="wage_type" name="wage_type" v-model="dedicated.wage_type">
                    <option
                            v-bind:key="index"
                            v-for="(wage_type, index) in wage_types"
                            v-bind:value="wage_type.value"
                            :selected="wage_type.value"
                    >
                        {{ wage_type.name }}
                    </option>
                </kt-form-select>
            </kt-form-group>

            <disabled-input
                    v-if="dedicated.psp"
                    :title="$t('label.psp')"
                    :val="find_psp"
                    idf="psp"
            ></disabled-input>

            <transition name="fade">
                <kt-form-group v-if="dedicated.wage_type == 1">
                    <kt-form-label>
                        {{ $t('label.change_wage_period') }}
                    </kt-form-label>
                    <kt-form-select
                            size="4"
                            id="wage_periodic_type"
                            name="wage_periodic_type"
                            v-model="dedicated.wage_periodic_type"
                    >
                        <option
                                v-bind:key="index"
                                v-for="(wage_periodic_type, index) in wage_periodic_types"
                                v-bind:value="wage_periodic_type.value"
                                :selected="wage_periodic_type.value"
                        >
                            {{ wage_periodic_type.name }}
                        </option>
                    </kt-form-select>
                </kt-form-group>
            </transition>
            <transition name="fade">
                <kt-form-group>
                    <kt-form-label>
                        {{
                        (dedicated.wage_type == 3) ?
                        $t('label.wage_amount_percent') :
                        ((dedicated.wage_type == 2) ?
                        $t('label.wage_amount_fixed') :
                        $t('label.wage_amount_periodic'))
                        }}
                    </kt-form-label>
                    <div class="kt-input-icon kt-input-icon--left">
                        <kt-form-control dir="ltr" id="wage_amount" name="wage_amount" v-model="dedicated.wage_amount">
                        </kt-form-control>
                        <span class="kt-input-icon__icon kt-input-icon__icon--left">
                            <span>{{
                                (dedicated.wage_type == 3) ?
                                $t('label.percent'):
                                $t('currency.rial')
                                }}</span>
                        </span>
                    </div>
                </kt-form-group>
            </transition>
            <transition name="fade">
                <kt-form-group v-if="dedicated.wage_type == 3">
                    <kt-form-label>
                        {{ $t('label.max_wage_amount') }}
                    </kt-form-label>
                    <div class="kt-input-icon kt-input-icon--left">
                        <kt-form-control dir="ltr" id="wage_max_wage" name="wage_max_wage" v-model="dedicated.wage_max_wage">
                        </kt-form-control>
                        <span class="kt-input-icon__icon kt-input-icon__icon--left">
                            <span>{{ $t('currency.rial') }}</span>
                        </span>
                    </div>
                </kt-form-group>
            </transition>

            <kt-form-action class="mt-4">
                <button class="btn btn-md btn-success btn-wide" type="submit" id="change_status_btn">
                    {{ $t('btn.edit') }}
                </button>
            </kt-form-action>
        </form>
    </kt-col>
</kt-row>
</template>

<script>
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { dedicatedStatusStr, dedicatedStatus } from '@/constants/dedicatedStatus'
import pspSelectModal from './psp-select-modal'
import { dedicatedService } from '@/common/api.service'
import { i18n } from '@/plugins/i18n'
import pspFrom from './psp-form'
import { disabledInput } from './pspDataComponents'

export default {
    components: {
        'psp-form': pspFrom,
        'psp-select-modal': pspSelectModal,
        disabledInput,
    },
    props: {
        dedicated: {
            required: true,
        },
        status: {
            required: true,
        },
    },
    computed: {
        find_psp(){
            return i18n.t('psp_list.' + this.dedicated.psp)
        }
    },
    data() {
        return {
            dedicatedStatus: dedicatedStatus,
            statuses: [
                {
                    name: dedicatedStatusStr.ACTIVE,
                    value: dedicatedStatus.ACTIVE
                },
                {
                    name: dedicatedStatusStr.PENDING,
                    value: dedicatedStatus.PENDING
                },
                {
                    name: dedicatedStatusStr.REJECTED,
                    value: dedicatedStatus.REJECTED
                },
                {
                    name: dedicatedStatusStr.BLOCKED,
                    value: dedicatedStatus.BLOCKED
                },
                {
                    name: dedicatedStatusStr.SEND_TO_PSP,
                    value: dedicatedStatus.SEND_TO_PSP
                },
                {
                    name: dedicatedStatusStr.REJECTED_BY_PSP,
                    value: dedicatedStatus.REJECTED_BY_PSP
                },
            ],
            wage_types: [
                {
                    name: this.$t('gateway.wage_types.percent'),
                    value: 3
                },
                {
                    name: this.$t('gateway.wage_types.fixed'),
                    value: 2
                },
                {
                    name: this.$t('gateway.wage_types.periodic'),
                    value: 1,
                }
            ],
            wage_periodic_types: [
                {
                    name: this.$t('gateway.wage_periodic_types.1'),
                    value: 1
                },
                {
                    name: this.$t('gateway.wage_periodic_types.3'),
                    value: 3
                },
                {
                    name: this.$t('gateway.wage_periodic_types.6'),
                    value: 6,
                },
                {
                    name: this.$t('gateway.wage_periodic_types.12'),
                    value: 12,
                }
            ]
        }
    },
    methods: {
        edit(e) {
            let btn = $('#change_status_btn')
            let form = $('#settings_form')
            KTApp.progress(btn)

            let is_failed = false
            dedicatedService.changeSettings(this.dedicated.id, {
                wage_type: this.dedicated.wage_type,
                wage_periodic_type: this.dedicated.wage_periodic_type,
                wage_amount: this.dedicated.wage_amount,
                wage_max_wage: this.dedicated.wage_max_wage,
                status: this.dedicated.status,
                rejection_reason: this.dedicated.rejection_reason
            })
                .then(this.$store.dispatch('badgeCounter/countData'))
                .catch(({response}) => {
                    is_failed = true
                })
                .finally(
                    response => {
                        KTApp.unprogress(btn)
                    }
                )

            if (is_failed) {
                this.showMsg(form, 'danger', i18n.t('message.an_error_accord'))
            } else {
                this.showMsg(form, 'success', i18n.t('message.changes_submitted_successfully'))
            }
        },
    },
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>